<template>
    <!-- v-model:visible="visibleColumn" -->
  <el-popover placement="bottom" width="160">
    <el-checkbox-group v-model="checkColumnList">
      <el-checkbox v-for="(item, index) in columnList" :key="index" :label="item" />
    </el-checkbox-group>
    <div style="text-align: right; margin: 0">
      <!-- <el-button size="small" text @click="visibleColumn = false">取消</el-button> -->
      <el-button size="small" type="primary" @click="saveColumn">确定</el-button>
    </div>
    <template #reference>
      <el-button type="primary" link @click="visibleColumn = true">
        显示表列<el-icon class="el-icon--right"><arrow-down /></el-icon>
      </el-button>
    </template>
  </el-popover>
</template>

<script>
export default {
  name: 'SelectTableColumn',
  data () {
    return {
      // visibleColumn: false,
      checkColumnList: [],
      // 默认列
      columnList: this.colList
    }
  },
  // 表列保存名称，表列的名称列
  props: ['colName', 'colList'],
  mounted () {
    // 获取当前用户保存的表列
    var arrCol = this.$storage.get(this.colName)
    // console.log('arrCol=', arrCol)
    // 为null时默认全选
    if (arrCol === null || arrCol.length === 0) {
      this.checkColumnList = this.columnList
    } else {
      this.checkColumnList = arrCol
    }
    // 子组件修改父组件数据
    this.$parent.checkColList = this.checkColumnList
  },
  methods: {
    saveColumn () {
      // this.visibleColumn = false
      // 返回一个新的数组
      const cList = this.columnList.slice()
      // 显示列是否与默认列相同
      if (cList.sort().toString() === this.checkColumnList.sort().toString()) {
        // 相同就清空保存的列
        this.$storage.remove(this.colName)
      } else {
        this.$storage.set(this.colName, this.checkColumnList)
      }
      // 子组件修改父组件数据
      this.$parent.checkColList = this.checkColumnList
    }
  }
}
</script>

<style scoped>
  .el-popover .el-checkbox{
    display: block;
    margin: 5px;
  }
  .el-icon--right{
    margin-right: 5px;
  }
</style>
